<template>
  <modal class="q-modal rate-limitie-config" name="rate-config-modal" :class="ifTop"
       transition="nice-modal-fade"
       :width="575"
       :min-width="575"
       :delay="100"
       :draggable="'.modal-header'"
       :clickToClose="false"
       :adaptive="true"
       @opened="Opened"
       classes='q-v--modal'>
    <div class="modal-content">
      <div class="modal-header">
        {{$t('rate.configRate')}}
      </div>
      <div class="icon-btn_close modal-close" @click="onClose()"></div>
      <scrollbar ref="scrollbar" class="scrollbar-body">
        <div class="modal-body">
          <div class="modal-container">
            <div class="formRow">
              <div class="title">{{$t('rate.port')}} </div>
              <div class="forminput">{{selPort}}</div>
            </div>
            <div class="formRow">
              <div class="title">{{$t('rate.applyTo')}}</div>
              <div class="formlabel fontB" @click="onSelection('all')">
                  <checkbox class="q-checkbox-label" :checked="isSelectAll" :label="$t('all')"></checkbox>
              </div>
              <div class="forminput port-table">
                <div class="port-select top">
                  <table>
                    <tr class="table-header">
                      <td style="width:36%;">{{$t('menu.port')}}</td>
                      <td style="width:8%;" v-for="num in 8" :key="num*2">{{num*2}}</td>
                    </tr>
                    <tr class="table-body">
                      <td class="table-body-content" style="width:36%;">{{$t('selected')}}</td>
                      <td class="table-body-content" style="width:8%;" v-for="num in 8" :key="num*2">
                        <div class="formlabel fontB subitem" @click="onSelection(num*2)">
                            <checkbox class="q-checkbox-label" :checked="isItemChecked(num*2)" :disabled="getDisable(num*2)"></checkbox>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="port-select bottom">
                  <table>
                    <tr class="table-header">
                      <td style="width:36%;">{{$t('menu.port')}}</td>
                      <td style="width:8%;" v-for="num in 8" :key="num*2-1">{{num*2-1}}</td>
                    </tr>
                    <tr class="table-body">
                      <td class="table-body-content" style="width:36%;">{{$t('selected')}}</td>
                      <td class="table-body-content" style="width:8%;" v-for="num in 8" :key="num*2-1">
                        <div class="formlabel fontB subitem" @click="onSelection(num*2-1)">
                            <checkbox class="q-checkbox-label" :checked="isItemChecked(num*2-1)" :disabled="getDisable(num*2-1)"></checkbox>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="formRow">
              <div class="title">{{$t('rate.limiting')}}</div>
              <div class="formlabel fontB" @click="onSameClick()">
                <checkbox class="q-checkbox-label" :checked="isSame" :label="$t('rate.fixRate')"></checkbox>
              </div>
              <div class="ingress-rate">
                <div class="title">{{$t('rate.ingress')}}</div>
                <div class="content">
                  <vue-slider ref="slider" class="slide" width="200px" v-model="ingressModel" @callback="ingressCb" :tooltip=false :min="minProgress" :max="maxProgress" :bg-style="sliderStyle.barStyle" :slider-style="sliderStyle.dotStyle" :process-style="sliderStyle.dotStyle" :piecewise-style="sliderStyle.barStyle" :piecewise=true >
                    <div slot="piecewise" slot-scope="props" class="piecewise">
                      <span v-if="props.index === 0">{{ props.label }}</span>
                      <span v-if="props.index === 1000">{{ props.label }}</span>
                    </div>
                  </vue-slider>
                  <input type="text" name="ingress" class="limit-text" v-model="textModel[0]" :disabled="getDisable('ingress')" v-validate="'required|numeric|max_value:1000|min_value:0'" :class="{'error': errors.has('ingress')}" @keyup="onBlur"/> Mbps
                  <div class="formlabel fontB unlimit" @click="onLimitSelect('ingress')">
                    <checkbox class="q-checkbox-label" :checked="isSelectLimit('ingress')" :label="$t('rate.noLimit')"></checkbox>
                  </div>
                </div>
                <div v-show="errors.has('ingress')" class="errorMessage">{{setErrorMessage(errors.first('ingress'))}}</div>
              </div>
              <div class="egress-rate">
                <div class="content">
                  <div class="title">{{$t('rate.egress')}}</div>
                  <vue-slider ref="slider" class="slide" width="200px" v-model="egressModel" @callback="egressCb" :tooltip=false :min="minProgress" :max="maxProgress" :bg-style="sliderStyle.barStyle" :slider-style="sliderStyle.dotStyle" :process-style="sliderStyle.dotStyle" :piecewise-style="sliderStyle.barStyle" :piecewise=true :disabled="getDisable('egress')">
                    <div slot="piecewise" slot-scope="props" class="piecewise">
                      <span v-if="props.index === 0">{{ props.label }}</span>
                      <span v-if="props.index === 1000">{{ props.label }}</span>
                    </div>
                  </vue-slider>
                  <input type="text" name="egress" class="limit-text" v-model="textModel[1]" :disabled="getDisable('egress')" v-validate="'required|numeric|max_value:1000|min_value:0'" :class="{'error': errors.has('egress')}" @keyup="onBlur"/> Mbps
                  <div class="formlabel fontB unlimit" @click="onLimitSelect('egress')">
                    <checkbox class="q-checkbox-label" :checked="isSelectLimit('egress')" :label="$t('rate.noLimit')"></checkbox>
                  </div>
                </div>
                <div v-show="errors.has('egress')" class="errorMessage">{{setErrorMessage(errors.first('egress'))}}</div>
              </div>
            </div>
          </div>
        </div>
      </scrollbar>
      <div class="modal-footer">
        <div class="footer-left">
        </div>
        <div class="footer-right">
          <!-- <button class="q-button cancel" @click="onClose()">{{$t('cancel')}}</button> -->
          <button class="q-button blue-btn-full" @click="onSaveClick()" :disabled="saveBtn">{{$t('save')}}</button>
          <button class="q-button" @click="onClose()">{{$t('cancel')}}</button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import checkbox from './module/Checkbox'
import vueSlider from 'vue-slider-component'
export default {
  name: 'RateConfig',
  props: {
    selectItem: Object,
    onChange: Function
  },
  components: {
    checkbox,
    vueSlider
  },
  data () {
    return {
      modalname: 'rate-config-modal',
      showModal: true,
      selPort: '',
      rateObject: {},
      enabled: false,
      selectedList: [],
      disableItem: [],
      portList: [],
      isSelectAll: false,
      ingressModel: 0,
      egressModel: 0,
      textModel: [],
      minProgress: 0,
      maxProgress: 1000,
      sliderStyle: {
        dotStyle: {
          backgroundColor: '#4875F5'
        },
        progressStyle: {
          backgroundColor: '#4875F5',
          height: '2px'
        },
        barStyle: {
          backgroundColor: '#979797',
          height: '2px'
        }
      },
      isSame: false,
      selectedLimit: [],
      portMsg: '',
      saveBtn: false,
      target: ''
    }
  },
  watch: {
    selectItem: function (value) {
      this.rateObject = this.selectItem
      this.ingressModel = this.rateObject.val.Cir / 1000
      this.egressModel = this.rateObject.val.EgressCir / 1000
      if (!this.rateObject.val.Enable) {
        this.textModel[0] = this.$t('rate.noLimit')
        this.selectedLimit.push('ingress')
        this.ingressModel = this.maxProgress
      } else {
        this.textModel[0] = this.ingressModel
      }
      if (!this.rateObject.val.EgressEnable) {
        this.textModel[1] = this.$t('rate.noLimit')
        this.selectedLimit.push('egress')
        this.egressModel = this.maxProgress
      } else {
        this.textModel[1] = this.egressModel
      }
      this.selPort = parseInt(this.rateObject.key)
      this.selectedList.push(this.selPort)
      this.portMsg = this.$t('rate.settingPort', [this.selPort])
      this.$log.debug(this.rateObject)
    },
    textModel: function (value) {
      if (this.isSame) {
        switch (this.target) {
          case 'ingress':
            this.ingressModel = value[0]
            this.egressModel = value[0]
            this.textModel[1] = value[0]
            break
          case 'egress':
            this.ingressModel = value[1]
            this.egressModel = value[1]
            this.textModel[0] = value[1]
            break
        }
      } else {
        if (value[0] === 'Unlimited') {
          this.ingressModel = value[0]
        } else {
          this.ingressModel = parseInt(value[0])
        }
        if (value[1] === 'Unlimited') {
          this.egressModel = value[1]
        } else {
          this.egressModel = parseInt(value[1])
        }
      }
    }
  },
  created: async function () {
    for (var index = 0; index < 16; index++) {
      let number = index + 1
      this.portList.push(number.toString())
    }
  },
  methods: {
    ...mapMutations(['openModal', 'closeModal']),
    ...mapActions(['setIngressRate', 'setEgressRate']),
    Opened (event) {
      const modal = document.querySelector('.v--modal-box.q-v--modal')
      let height = document.body.clientHeight
      let temph = (height > 600) ? 600 : height - 90
      if (modal) {
        modal.style.height = temph + 'px'
        modal.style.top = 'calc(50% - ' + (temph / 2) + 'px'
      }
    },
    onOpen () {
      this.openModal(this.modalname)
      this.$modal.show(this.modalname)
    },
    onClose () {
      this.onChange()
      this.closeModal(this.modalname)
      this.$modal.hide(this.modalname)
      this.selPort = ''
      this.selectedList = []
    },
    getLabelName: function (item) {
      return toString(item)
    },
    onSelection: function (item) {
      if (this.selPort !== item) {
        if (item === 'all') {
          this.isSelectAll = !this.isSelectAll
          if (this.isSelectAll) {
            let temp = []
            for (var index = 0; index < 16; index++) {
              let number = index + 1
              temp.push(number)
            }
            this.selectedList = temp
          } else {
            this.selectedList = []
            this.selectedList.push(this.selPort)
          }
        } else {
          this.isSelectAll = false
          let index = this.selectedList.indexOf(item)
          if (index > -1) {
            this.selectedList.splice(index, 1)
          } else {
            this.selectedList.push(item)
          }
        }
        let sortArray = this.selectedList
        sortArray.sort(function (a, b) {
          return a - b
        })
        this.portMsg = this.$t('rate.settingPort', [sortArray])
      }
    },
    onBlur: function (event) {
      this.target = event.target.name
      this.$validator.validateAll().then((result) => {
        this.saveBtn = !result
      })
    },
    isItemChecked: function (item) {
      let index = this.selectedList.indexOf(item)
      return (index > -1)
    },
    getDisable: function (item) {
      if (item !== 'egress' && item !== 'ingress') {
        if (item !== this.selPort) {
          return false
        } else {
          return true
        }
      }
    },
    onLimitSelect: function (item) {
      if (this.isSame) {
        let textValue = null
        if (this.selectedLimit.length === 0) {
          this.selectedLimit = ['ingress', 'egress']
          this.ingressModel = this.maxProgress
          textValue = this.$t('rate.noLimit')
        } else {
          this.selectedLimit = []
          textValue = 1000
        }
        this.egressModel = this.ingressModel
        this.textModel[0] = textValue
        this.textModel[1] = textValue
      } else {
        if (item === 'ingress') {
          let index = this.selectedLimit.indexOf('ingress')
          if (index > -1) {
            this.ingressModel = this.rateObject.val.Cir / 1000
            this.textModel[0] = this.ingressModel
            this.selectedLimit.splice(index, 1)
          } else {
            this.ingressModel = this.maxProgress
            this.textModel[0] = this.$t('rate.noLimit')
            this.selectedLimit.push('ingress')
          }
        } else {
          let index = this.selectedLimit.indexOf('egress')
          if (index > -1) {
            this.egressModel = this.rateObject.val.Cir / 1000
            this.selectedLimit.splice(index, 1)
          } else {
            this.egressModel = this.maxProgress
            this.textModel[1] = this.$t('rate.noLimit')
            this.selectedLimit.push('egress')
          }
        }
      }
    },
    isSelectLimit: function (item) {
      return (this.selectedLimit.indexOf(item) > -1)
    },
    onSameClick: function () {
      this.isSame = !this.isSame
      if (this.isSame) {
        if (this.selectedLimit.indexOf('ingress') > -1) {
          this.textModel[1] = this.$t('rate.noLimit')
        } else {
          this.selectedLimit = []
          this.textModel[0] = this.egressModel
          this.textModel[1] = this.egressModel
        }
        this.egressModel = this.ingressModel
      }
    },
    ingressCb: function (value) {
      var index = this.selectedLimit.indexOf('ingress')
      if (this.isSame) {
        if (index > -1) {
          this.selectedLimit = []
        }
        this.egressModel = value
        this.ingressModel = value
        this.textModel[0] = value
        this.textModel[1] = value
      } else {
        this.textModel[0] = this.ingressModel
        if (index > -1) {
          this.selectedLimit.splice(index, 1)
        }
      }
    },
    egressCb: function (value) {
      var index = this.selectedLimit.indexOf('egress')
      if (this.isSame) {
        if (index > -1) {
          this.selectedLimit = []
        }
        this.egressModel = value
        this.ingressModel = value
        this.textModel[0] = value
        this.textModel[1] = value
      } else {
        this.textModel[1] = this.egressModel
        if (index > -1) {
          this.selectedLimit = []
        }
      }
    },
    onSaveClick: function () {
      var ingressData = {}
      var EgressData = {}
      var count = 0
      var ingEnable = null
      var egEnable = null
      if (this.selectedLimit.indexOf('ingress') > -1) {
        ingEnable = false
      } else {
        ingEnable = true
      }
      if (this.selectedLimit.indexOf('egress') > -1) {
        egEnable = false
      } else {
        egEnable = true
      }
      this.selectedList.forEach(element => {
        ingressData = {
          'key': 'Gi 1/' + element,
          'val': {
            'Cir': this.ingressModel * 1000,
            'Enable': ingEnable,
            'FlowControl': this.rateObject.val.FlowControl,
            'FrameRate': this.rateObject.val.FrameRate
          }
        }
        this.setIngressRate(ingressData).then((res) => {
          this.$log.debug(res)
          EgressData = {
            'key': 'Gi 1/' + element,
            'val': {
              'Cir': this.egressModel * 1000,
              'Enable': egEnable
            }
          }
          this.setEgressRate(EgressData).then((res) => {
            this.$log.debug(res)
            count++
            this.$log.debug(count)
            if (count === this.selectedList.length) {
              this.onClose()
            }
          })
            .catch(error => {
              this.$log.error(error)
            })
        })
          .catch(error => {
            this.$log.error(error)
          })
      })
    },
    setErrorMessage: function (data) {
      let message = ''
      if (data) {
        if (data.indexOf('required') > -1) {
          message = this.$t('errorMessage.isReguired')
        } else {
          message = this.$t('errorMessage.rateRange')
        }
      }
      return message
    }
  },
  computed: {
    ...mapGetters(['getTopModalName']),
    ifTop () {
      this.$log.debug('this.getTopModalName' + this.getTopModalName)

      if (this.getTopModalName !== this.modalname) {
        return 'noTopModal'
      } else {
        return 'none'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';

@import '../assets/scss/modal.scss';

.rate-limitie-config {
  .formRow {
    margin-bottom: 10px;
    >.title, >.forminput, >.subitem {
      display: inline-block;
    }
    >.subitem {
      width: 145px;
    }
    .ingress-rate, .egress-rate {
      margin-left: 30px;
      >.content {
        >.slide {
          width: 200px;
          display: inline-block;
        }
        >.limit-text {
          margin: 15px 0px 0px 15px;
          width: 78px;
        }
        >.unlimit {
          display: inline-block;
          position: relative;
          top: 8px;
          margin-left: 30px;
        }
      }
      >.errorMessage {
        padding-left: 218px;
      }
    }
    .egress-rate {
      margin-top: 10px;
    }
    .forminput {
      padding: 0px 10px;
      &.port-table {
        width: 100%;
      }
      .port-select {
        margin-top: 10px;
        >table {
          margin-top: 5px;
          width: 100%;
          text-align: center;
          td {
            border: 1px solid #F1F1F1;
          }
          .table-header {
            background: #F2F3F8;
            height: 28px;
            text-align: center;
          }
          .table-body {
            height: 38px;
            .q-checkbox.q-checkbox-label {
              display: inline-table;
            }
          }
        }
      }
    }
    .slide {
      top: 12px;
    }
    .piecewise {
      float: right;
      margin-top: -25px;
    }
    .select-port-msg {
      margin-top: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RateConfig.vue